"use client";

import { useQuery } from "@tanstack/react-query";
import { getCurrentUserAction } from "@/resources/actions/auth.actions";
import { queryKeys } from "@/lib/query-keys";

/**
 * Current user query hook
 * Fetches the currently authenticated user
 */
export function useCurrentUser() {
  return useQuery({
    queryKey: queryKeys.auth.currentUser(),
    queryFn: async () => {
      return await getCurrentUserAction();
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    // Note: Retry logic is handled globally in Web3Provider
  });
}
